/**
 * AdGeneratorFooterLink — the footer link to the AI video ad generator, in
 * the page's language (shared/adGeneratorLink.ts): the localized ad page,
 * named with its localized h1. Rendered in the homepage footer (LandingV2)
 * and the CreativeLandingShell footer; the homepage crawler HTML carries the
 * same link (renderHomepageFooterLink in server/_core/seo.ts). A real
 * <a href> that navigates client-side on a plain click. Renders nothing on
 * the ad page itself.
 */
import type { MouseEvent } from "react";
import { useLanguageRouter } from "@/hooks/useLanguageRouter";
import { AD_GENERATOR_PATH, adGeneratorLinkLabel } from "@shared/adGeneratorLink";

export default function AdGeneratorFooterLink() {
  const { currentLang, pathWithoutLang, withLanguagePath, navigate } =
    useLanguageRouter();
  if (pathWithoutLang.split(/[?#]/)[0] === AD_GENERATOR_PATH) return null;

  const onClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) {
      return;
    }
    e.preventDefault();
    navigate(AD_GENERATOR_PATH);
  };

  return (
    <a href={withLanguagePath(AD_GENERATOR_PATH)} onClick={onClick}>
      {adGeneratorLinkLabel(currentLang)}
    </a>
  );
}
